import uploadPassengers from './uploadPassengers'
import fetchPassengers from './fetchPassengers'
import deletePassengers from './deletePassengers'
import validateDeletePassengers from './validateDeletePassengers'
import checkOutPassenger from './checkOutPassenger'

export default [
  uploadPassengers,
  fetchPassengers,
  deletePassengers,
  validateDeletePassengers,
  checkOutPassenger,
]
